module.exports = __webpack_public_path__ + "static/media/S3.262df15b.png";